import { useCallback, useEffect, useState } from 'react';

const cache = new Map<string, Promise<any[]>>();

export default function useReferenceList<T>(key: string, load: () => Promise<T[]>): {
  data: T[] | null;
  loading: boolean;
  error: unknown;
  append: (item: T) => void;
} {
  const [data, setData] = useState<T[] | null>(null);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    let active = true;
    let request = cache.get(key);
    if (!request) {
      request = load();
      cache.set(key, request);
      request.catch(() => cache.delete(key));
    }
    request.then(
      (items) => active && setData(items),
      (err) => active && setError(err)
    );
    return () => {
      active = false;
    };
  }, [key, load]);

  const append = useCallback(
    (item) => {
      setData((current) => {
        const next = [...(current || []), item];
        cache.set(key, Promise.resolve(next));
        return next;
      });
    },
    [key]
  );

  return { data, loading: !data && !error, error, append };
}
